import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8.006 1.246A6.75 6.75 0 1 0 14.756 8a6.76 6.76 0 0 0-6.75-6.754Zm0 12A5.25 5.25 0 1 1 13.256 8a5.256 5.256 0 0 1-5.25 5.246Zm4.62-4.13L9.286 8.2a.2.2 0 0 0-.26.19v1.9a.2.2 0 0 1-.31.17l-5.3-3.58 3.41.95a.213.213 0 0 0 .26-.2V5.706a.2.2 0 0 1 .31-.16Z';
const draw24px =
  'M12,2.246A9.75,9.75,0,1,0,21.746,12,9.769,9.769,0,0,0,12,2.246Zm0,18A8.25,8.25,0,1,1,20.246,12,8.265,8.265,0,0,1,12,20.246Zm6.94-6.57-5.01-1.38a.3.3,0,0,0-.38.29v2.85a.3.3,0,0,1-.47.25l-7.95-5.36,5.11,1.41a.3.3,0,0,0,.38-.29V8.566a.3.3,0,0,1,.47-.25Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BoltCircleIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'boltCircle'),
) as IconWithRender;

BoltCircleIcon.displayName = 'BoltCircleIcon';
BoltCircleIcon.propTypes = Icon.propTypes;
BoltCircleIcon.renderIcon = (props) => <BoltCircleIcon {...props} />;
export default BoltCircleIcon;
